import { Component } from '@angular/core';

@Component({
  selector: 'app-exchange-order',
  templateUrl: './exchange-order.component.html',
  styleUrl: './exchange-order.component.scss'
})
export class ExchangeOrderComponent {

}
